import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import { pdfColors, pdfSpacing } from '../theme';

interface Props {
  dashed?: boolean;
  marginY?: number;
}

const styles = StyleSheet.create({
  solid: {
    borderBottomWidth: 0.6,
    borderBottomColor: pdfColors.divider,
    borderBottomStyle: 'solid',
  },
  dashed: {
    borderBottomWidth: 0.6,
    borderBottomColor: pdfColors.divider,
    borderBottomStyle: 'dashed',
  },
});

/** A faint horizontal rule. Use between unrelated sections; between related
 *  rows of the same section, use spacing instead. */
const Divider: React.FC<Props> = ({ dashed, marginY = pdfSpacing.md }) => (
  <View style={[dashed ? styles.dashed : styles.solid, { marginTop: marginY, marginBottom: marginY }]} />
);

export default Divider;
